/**
 * cast の認証モジュール。実体は共有モジュール（@new-cti/frontend-shared）。
 * createAuth(appConfig) の戻り値を名前付き再エクスポートするため、呼び出し側の
 * `import { getAuthToken, ... } from '@/lib/auth'` は従来どおり動く。authClient は SSE hooks 注入用。
 */
import { createAuth, type CurrentUserInfo } from '@new-cti/frontend-shared/auth/auth-core';
import { appConfig } from './app-config';

export const authClient = createAuth(appConfig);

export const {
  signIn,
  confirmNewPassword,
  requestPasswordReset,
  confirmPasswordReset,
  signOut,
  clearAuth,
  isAuthenticated,
  getAuthToken,
  refreshAuthToken,
  handleApiAuthError,
  getCurrentUserInfo,
} = authClient;

export type { CurrentUserInfo };
